import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.875 9.9V13.5C1.875 13.858 2.01723 14.2014 2.27041 14.4546C2.52358 14.7078 2.86696 14.85 3.225 14.85H14.775C15.133 14.85 15.4764 14.7078 15.7296 14.4546C15.9828 14.2014 16.125 13.858 16.125 13.5V9.9L14.55 3.75H3.45L1.875 9.9ZM16.125 9.9H11.925L10.875 11.85H7.125L6.075 9.9H1.875",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInbox;
